import Textfield from "../../../common/components/Textfiled.jsx";
import Button from "../../../common/components/Button.jsx";

function FormSpeedManagment({
  speedManagment,
  onChange,
  onSubmit,
  onCancel,
  errors = {},
  submitLabel = "Guardar",
  loading = false,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="container mt-4">
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Mes</label>
          <input
            className={`form-control ${errors.date ? "is-invalid" : ""}`}
            type="month"
            value={speedManagment.date ? String(speedManagment.date).substring(0, 7) : ""}
            onChange={(e) =>
              onChange({
                name: "date",
                value: e.target.value ? `${e.target.value}-01` : "",
              })
            }
          />
          {errors.date && (
            <div className="invalid-feedback d-block">{errors.date}</div>
          )}
        </div>

        <div className="col-md-6">
          <Textfield
            label="Vehículos propios en programa"
            placeholder="Vehículos propios en programa"
            type="number"
            name="ownInProgram"
            value={speedManagment.ownInProgram}
            onChange={onChange}
            error={errors.ownInProgram}
          />
        </div>
        <div className="col-md-6">
          <Textfield
            label="Vehículos propios usados en el mes"
            placeholder="Vehículos propios usados en el mes"
            type="number"
            name="ownUsedMonth"
            value={speedManagment.ownUsedMonth}
            onChange={onChange}
            error={errors.ownUsedMonth}
          />
        </div>
        <div className="col-md-6">
          <Textfield
            label="Vehículos contratistas en programa"
            placeholder="Vehículos contratistas en programa"
            type="number"
            name="contractorsInProgram"
            value={speedManagment.contractorsInProgram}
            onChange={onChange}
            error={errors.contractorsInProgram}
          />
        </div>
        <div className="col-md-6">
          <Textfield
            label="Vehículos contratistas usados en el mes"
            placeholder="Vehículos contratistas usados en el mes"
            type="number"
            name="contractorsUsedMonth"
            value={speedManagment.contractorsUsedMonth}
            onChange={onChange}
            error={errors.contractorsUsedMonth}
          />
        </div>
        <div className="col-md-6">
          <Textfield
            label="Terceros en el programa"
            placeholder="Terceros en el programa"
            type="number"
            name="thirdPartiesInProgram"
            value={speedManagment.thirdPartiesInProgram}
            onChange={onChange}
            error={errors.thirdPartiesInProgram}
          />
        </div>
        <div className="col-md-6">
          <Textfield
            label="Vehículos terceros usados en el mes"
            placeholder="Vehículos terceros usados en el mes"
            type="number"
            name="thirdPartiesUsedMonth"
            value={speedManagment.thirdPartiesUsedMonth}
            onChange={onChange}
            error={errors.thirdPartiesUsedMonth}
          />
        </div>
        <div className="col-12 d-flex justify-content-end gap-2 mt-3">
          {onCancel && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={loading}
            >
              Cancelar
            </button>
          )}
          <Button type="submit" loading={loading}>
            {submitLabel}
          </Button>
        </div>
      </div>
    </form>
  );
}

export default FormSpeedManagment;
